import {
    type FC,
    useId
} from "react";
import {
    Animated
} from "react-native";
import type IMessageScrollerFadeProps from "./type";
import stylesheet, {
    MESSAGE_SCROLLER_FADE_STOPS,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import {
    useMessageScrollerRootContext,
    useMessageScrollerSelector,
    useMessageScrollerContext
} from "../../context";
import {
    LinearGradient,
    Defs,
    Rect,
    Stop,
    Svg
} from "react-native-svg";

const MessageScrollerFadeContent: FC<IMessageScrollerFadeProps> = ({
    customTheme,
    edge
}) => {
    const context = useMessageScrollerContext();

    const rootContext = useMessageScrollerRootContext();

    const currentTheme = customTheme ?? rootContext?.customTheme;

    const {
        shapeConfigs,
        borders,
        spaces
    } = NCoreUIKitTheme.useContext(currentTheme);

    const isVisible = useMessageScrollerSelector(context, (snapshot) => edge === "start" ? snapshot.isFadeStart : snapshot.isFadeEnd, false);

    const isFocusVisible = useMessageScrollerSelector(context, (snapshot) => snapshot.isFocusVisible, false);

    const gradientID = useId().replace(/[^a-zA-Z0-9]/g, "");

    const opacity = useAnimatedState({
        customTheme: currentTheme,
        value: isVisible ? 1 : 0,
        intent: "hover"
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        isFocusVisible,
        shapeConfigs,
        borders,
        spaces,
        edge
    });

    const [
        fromOpacity,
        toOpacity
    ] = MESSAGE_SCROLLER_FADE_STOPS[edge];

    return <Animated.View
        style={[
            stylesheet.container,
            edge === "start" ? stylesheet.top : stylesheet.bottom,
            containerDynamicStyle,
            {
                opacity
            }
        ]}
        aria-hidden={true}
    >
        <Svg
            height="100%"
            width="100%"
        >
            <Defs>
                <LinearGradient
                    id={gradientID}
                    x1="0"
                    x2="0"
                    y1="0"
                    y2="1"
                >
                    <Stop
                        stopColor={rootContext?.fadeColor}
                        stopOpacity={fromOpacity}
                        offset="0"
                    />
                    <Stop
                        stopColor={rootContext?.fadeColor}
                        stopOpacity={toOpacity}
                        offset="1"
                    />
                </LinearGradient>
            </Defs>
            <Rect
                fill={`url(#${gradientID})`}
                height="100%"
                width="100%"
            />
        </Svg>
    </Animated.View>;
};

const MessageScrollerFade: FC<IMessageScrollerFadeProps> = (props) => {
    const context = useMessageScrollerContext();

    const isMeasured = useMessageScrollerSelector(context, (snapshot) => snapshot.isMeasured, false);

    if(context && !isMeasured) {
        return null;
    }

    return <MessageScrollerFadeContent
        {...props}
    />;
};
export default MessageScrollerFade;
